import { Container } from "@/components/layout/Container"
import { ProductAdvantages } from "@/components/sections/product/ProductAdvantages"
import { SplitFeature } from "@/components/sections/SplitFeature"
import { Eyebrow } from "@/components/shared/Eyebrow"
import { PageMeta } from "@/components/shared/PageMeta"
import { PAGE_SEO } from "@/lib/seo"
import { imageBaseURL } from "@/lib/utils"
import { CalendarClock, Store, Truck } from "lucide-react"

const imgAboutUs = {
	sm: imageBaseURL("lab-cdmx-sm.webp"),
	lg: imageBaseURL("lab-cdmx-lg.webp")
}

const contentBusiness = [
	{ icon: Truck, title: "Envíos a todo México", text: "Llegamos a toda la republica mexicana de 1 a 3 días hábiles." },
	{
		icon: Store,
		title: "Aceptamos todo tipo de pagos",
		text: "Pagos en efectivo, transferencias bancarias y tarjetas de crédito y débito."
	},
	{
		icon: CalendarClock,
		title: "Meses sin intereses",
		text: "A 3 y 6 meses en tarjetas de crédito participantes y montos mayores a $1,000."
	}
]

export function NosotrosPage(): React.JSX.Element {
	return (
		<div>
			<PageMeta {...PAGE_SEO.nosotros} path="/nosotros" />
			<Container className="py-16 md:py-24">
				<Eyebrow align="center">Sobre nosotros</Eyebrow>

				<h1 className="my-3 text-3xl font-bold text-center">Biosany Shalósh Bayóm</h1>
				<p className="text-muted-foreground text-center max-w-2xl mx-auto">
					Somos una empresa 100% mexicana, desde hace mas de 20 años nos dedicamos a distribuir una línea de
					tratamientos de bioestimulación celular con tecnología rusa AEQ. Nuestra misión es ayudar a las personas a
					mejorar su calidad de vida y a sanar sus problemas de salud.
				</p>
			</Container>

			<section className="bg-background">
				<Container className="pb-8 md:pb-24">
					<div className="mb-10 grid grid-cols-1 gap-10 md:mb-14 md:grid-cols-2 md:gap-12">
						<div className="text-center">
							<img
								src={imageBaseURL("tecnologia-aeq.webp")}
								alt=""
								aria-hidden
								loading="lazy"
								className="aspect-square w-full rounded-2xl object-cover"
							/>
							<h3 className="mt-6 text-balance text-xl font-semibold tracking-tight sm:text-2xl">
								La tecnología AEQ
							</h3>
							<p className="mt-3 text-pretty leading-relaxed text-muted-foreground">
								Durante la guerra fría, la URSS desarrolló tecnología capaz de auto-regenerar las células por
								medio de la bioestimulación celular y así proteger al cuerpo de virus y bacterias.
							</p>
							<p className="mt-3 text-pretty leading-relaxed text-muted-foreground">
								El Dr. Vitold M. Bakhir lo patentó como celdas de activación electroquímica, una sustancia que
								mezcla oxidantes cloroxigenados e hidroperóxidos activos de baja concentración.
							</p>
						</div>
						<div className="text-center">
							<img
								src={imageBaseURL("3-veces-al-dia.webp")}
								alt=""
								aria-hidden
								loading="lazy"
								className="aspect-square w-full rounded-2xl object-cover"
							/>
							<h3 className="mt-6 text-balance text-xl font-semibold tracking-tight sm:text-2xl">
								Tecnología para la salud
							</h3>
							<p className="mt-3 text-pretty leading-relaxed text-muted-foreground">
								Esta tecnología ha sido utilizada en el tratamiento de enfermedades crónicas por su alto contenido
								de oxígeno y su capacidad de estimular el metabolismo celular.
							</p>
							<p className="mt-3 text-pretty leading-relaxed text-muted-foreground">
								Hoy en dia miles de médicos en el mundo sanan a sus pacientes por medio de tecnologías de
								bioestimulación celular. Biosany Shalósh Bayóm® le ayuda a solucionar sus problemas de salud
								tomándolo 3 veces al día.
							</p>
						</div>
					</div>
				</Container>
			</section>

			<ProductAdvantages advantages={contentBusiness} title="Compras en línea 100% seguras" />

			<Eyebrow align="center" className="my-10 md:my-14">
				Laboratorios Biosany México
			</Eyebrow>
			<SplitFeature backgroundImage={imgAboutUs} />
		</div>
	)
}
